import store from "../../redux/store";

const isEnabled = (config, property) => config.hasOwnProperty(property) && config[property];

//handles requests going from app to server
const requestHandler = async (request) => {
    if (isEnabled(request, 'requestHandlerEnabled')) {
        const {
            auth: { authToken }
        } = store.getState();
        request.headers['Authorization'] = 'Bearer ' + authToken;
    }

    request.headers['Content-Type'] = !isEnabled(request, 'fileHandler') ? 'application/json' : 'multipart/form-data';
    request.headers['Access-Control-Allow-Methods'] = 'POST, GET, OPTIONS, DELETE';
    return request;
}

//handles responses coming from server to app
const successHandler = (response) => {
    if (isEnabled(response.config, 'responseHandlerEnabled')) {
        return response.data;
    }

    return response;
}

const errorHandler = async (error) => {
    const response = error.response;
    if (isEnabled(error.config, 'responseHandlerEnabled')) {
        //error response handling enabled
    }

    var message = "Something went wrong!";

    if (response) {
        message = response.data.Message || response.data || "Something went wrong on the server. Please contact the system administrator";

        //if 401 redirect to login page
        if (response.status === 401) {
            // Only redirect if not already on login page
            if (!window.location.pathname.includes('/login')) {
                localStorage.removeItem('persist:auth-token');
                window.location = window.origin + '/login';
                return;
            }
        }
        //if not authorized redirect to dashboard
        if (response.status === 403) {
            window.location = window.origin + '/';
            return;
        }
    }

    throw Error(message);
}

export {
    requestHandler,
    successHandler,
    errorHandler
}